import { render, staticRenderFns } from "./DrawerAvatarImg.vue?vue&type=template&id=0de3fb99&scoped=true&"
import script from "./DrawerAvatarImg.vue?vue&type=script&lang=js&"
export * from "./DrawerAvatarImg.vue?vue&type=script&lang=js&"
import style0 from "./DrawerAvatarImg.vue?vue&type=style&index=0&id=0de3fb99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de3fb99",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
